import { Component, OnInit, Input } from '@angular/core';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { PageNames } from 'ep-bt-controls';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-new-quick-order-product-details',
  templateUrl: './epbt-fa-new-quick-order-product-details.component.html',
  styleUrls: ['./epbt-fa-new-quick-order-product-details.component.scss']
})
export class EpbtFaNewQuickOrderProductDetailsComponent implements OnInit {




  pageNames = PageNames;
  isPopup = true;
  constructor(public productService: EpbtFaProductService, public quickOrderService: EpbtFaQuickOrderService) { }

  ngOnInit() {
  }

  onSaveOrCancelClick(flag) {
    if (!flag) {
      return;
    } else {
      this.productService.fromPage = PageNames.ProductSearch;
    }
    // this.instance.close();
  }
}
